import React from 'react'
import './Loading.scss'

const Loading = () => {
  return (
    <section className="loading-container">
      <div className="lds-facebook"><div></div><div></div><div></div></div>
    </section>
  )
}

export default Loading